<template>
	<main class="start-design-main" id="app">
		<section class="start-design-content">
			<section class="create-a-design">
				<div class="create-item-header">
					<h3 class="create-item-title">新建设计</h3>
					<div class="title-split"></div>
					<div class="create-new" @click.stop="clickCustomSize">自定义尺寸</div>
				</div>

				<!-- 分割线 -->
				<div class="item-split-line"></div>

				<section>
					<!-- 社交媒体 -->
					<div class="create-item-header-type" style="margin: 46px auto 22px">
						<h3 class="create-item-title-type">新媒体配图</h3>
					</div>
					<ul class="design-type-list" id="socialmedia">
						<li id="wx-main" @click="goDesign('wx-main')">
							<a>
								<img
									src="@/assets/image/startdesign/new_gzh_main.png"
									alt="公众号封面"
									style="width: 163px; height: 155px"
								/>
							</a>
							<div class="list_item_desc">
								<p>公众号封面首图</p>
								<p>900 x 383 px</p>
							</div>
						</li>
						<li id="wx-secondary-pro" @click="goDesign('wx-secondary-pro')">
							<a>
								<img
									src="@/assets/image/startdesign/new_gzh_second.png"
									alt="公众号底部小图"
									style="width: 138px; height: 155px"
								/>
							</a>
							<div class="list_item_desc">
								<p>公众号次图</p>
								<p>500 x 500 px</p>
							</div>
						</li>
						<li id="wx-qrcode" @click="goDesign('wx-qrcode')">
							<a style="alignitems: center">
								<img
									src="@/assets/image/startdesign/new_row_code.png"
									alt="公众号底部二维码(横)"
									style="width: 158px; height: 95px"
								/>
							</a>
							<div class="list_item_desc">
								<p>二维码(横)</p>
								<p>900 x 500 px</p>
							</div>
						</li>
						<li id="wx-qrcode-square" @click="goDesign('wx-qrcode-square')">
							<a style="alignitems: center">
								<img
									src="@/assets/image/startdesign/new_square_code.png"
									alt="公众号底部二维码(方)"
									style="width: 124px; height: 123px"
								/>
							</a>
							<div class="list_item_desc">
								<p>二维码(方)</p>
								<p>600 x 600 px</p>
							</div>
						</li>
						<li id="article-adorn" @click="goDesign('article-adorn')">
							<a>
								<img
									src="@/assets/image/startdesign/new_row_pic.png"
									alt="文章配图(横)"
									style="width: 135px; height: 155px"
								/>
							</a>
							<div class="list_item_desc">
								<p>横版文章配图</p>
								<p>1025 x 768 px</p>
							</div>
						</li>
						<li id="article-adorn-vertical" @click="goDesign('article-adorn-vertical')">
							<a>
								<img
									src="@/assets/image/startdesign/new_vertical_pic.png"
									alt="文章配图(竖)"
									style="width: 130px; height: 155px"
								/>
							</a>
							<div class="list_item_desc">
								<p>竖版文章配图</p>
								<p>1280 x 1920 px</p>
							</div>
						</li>
						<li id="hyperlink" @click="goDesign('hyperlink')">
							<a>
								<img
									src="@/assets/image/startdesign/new_link_pic.png"
									alt="超链接配图"
									style="width: 160px; height: 155px"
								/>
							</a>
							<div class="list_item_desc">
								<p>超链接Banner</p>
								<p>600 x 200 px</p>
							</div>
						</li>
						<li id="course-cover" @click="goDesign('course-cover')">
							<a>
								<img
									src="@/assets/image/startdesign/new_coursecover0615.png"
									alt="课程封面"
									style="width: 145px; height: 155px"
								/>
							</a>
							<div class="list_item_desc">
								<p>课程封面</p>
								<p>900 x 500 px</p>
							</div>
						</li>
						<li id="red-book" @click="goDesign('red-book')">
							<a>
								<img
									src="@/assets/image/startdesign/new_xiaohongshu.png"
									alt="小红书封面"
									style="width: 120px; height: 155px"
								/>
							</a>
							<div class="list_item_desc">
								<p>小红书配图</p>
								<p>1242 x 1660 px</p>
							</div>
						</li>
					
						<li id="view-tip" @click="goDesign('view-tip')">
							<a>
								<img
									src="@/assets/image/startdesign/new_tishi.png"
									alt="在看提示"
									style="width: 165px; height: 155px"
								/>
							</a>
							<div class="list_item_desc">
								<p>在看提示</p>
								<p>640 x 200 px</p>
							</div>
						</li>
						<li id="article-title" @click="goDesign('article-title')">
							<a>
								<img
									src="@/assets/image/startdesign/new_biaoti.png"
									alt="文章标题"
									style="width: 165px; height: 155px"
								/>
							</a>
							<div class="list_item_desc">
								<p>文章标题</p>
								<p>1080 x 200 px</p>
							</div>
						</li>
						<li id="cut-line" @click="goDesign('cut-line')">
							<a>
								<img
									src="@/assets/image/startdesign/new_fengexian.png"
									alt="分割线"
									style="width: 165px; height: 155px"
								/>
							</a>
							<div class="list_item_desc">
								<p>分割线</p>
								<p>1080 x 200 px</p>
							</div>
						</li>
						<li id="book-cover" @click="goDesign('book-cover')">
							<a style="alignitems: center">
								<img
									src="@/assets/image/startdesign/new_shujifengmian.png"
									alt="书籍封面"
									style="width: 104px; height: 144px"
								/>
							</a>
							<div class="list_item_desc">
								<p>书籍封面</p>
								<p>1242 x 1746 px</p>
							</div>
						</li>
					</ul>

					<!-- 广告营销 -->
					<div class="create-item-header-type" style="margin: 0 auto 22px">
						<h3 class="create-item-title-type">营销海报</h3>
					</div>
					<ul class="design-type-list" style="margin-top: 0">
						<li id="mobile-poster" @click="goDesign('mobile-poster')">
							<a>
								<img
									src="@/assets/image/startdesign/new_shoujihaibao_Pro.png"
									alt="手机海报Pro"
									style="width: 106px; height: 155px"
								/>
							</a>
							<div class="list_item_desc">
								<p>手机海报</p>
								<p>1242 x 2208 px</p>
							</div>
						</li>
						<li id="invitation" @click="goDesign('invitation')">
							<a style="alignitems: center">
								<img
									src="@/assets/image/startdesign/new_invite_pic.png"
									alt="邀请函"
									style="width: 81px; height: 140px"
								/>
							</a>
							<div class="list_item_desc">
								<p>邀请函</p>
								<p>720 x 1280 px</p>
							</div>
						</li>
						<li id="marketing-long-img" @click="goDesign('marketing-long-img')">
							<a style="alignitems: center">
								<img
									src="@/assets/image/startdesign/new_sale_pic.png"
									alt="营销长图"
									style="width: 72px; height: 161px"
								/>
							</a>
							<div class="list_item_desc">
								<p>营销长图</p>
								<p>800 x 2000 px</p>
							</div>
						</li>
						<li id="cross-edition-poster" @click="goDesign('cross-edition-poster')">
							<a style="alignitems: flex-start">
								<img
									src="@/assets/image/startdesign/new_row_poster.png"
									alt="横版海报"
									style="width: 152px; height: 144px"
								/>
							</a>
							<div class="list_item_desc">
								<p>横版海报</p>
								<p>900 x 500 px</p>
							</div>
						</li>
						<li id="logo" @click="goDesign('logo')">
							<a style="alignitems: center">
								<img
									src="@/assets/image/startdesign/new_logo_pic.png"
									alt="LOGO"
									style="width: 118px; height: 118px"
								/>
							</a>
							<div class="list_item_desc">
								<p>LOGO</p>
								<p>500 x 500 px</p>
							</div>
						</li>
						<li id="rectposter" @click="goDesign('rectposter')">
							<a style="alignitems: flex-start">
								<img
									src="@/assets/image/startdesign/new_fangxinhaibao.png"
									alt="方形海报"
									style="width: 118px; height: 161px"
								/>
							</a>
							<div class="list_item_desc">
								<p>方形海报</p>
								<p>1242 x 1242 px</p>
							</div>
						</li>
					</ul>

					<!-- 个人生活 -->

					<div class="create-item-header-type" style="margin: 0 auto 22px">
						<h3 class="create-item-title-type">社交生活</h3>
					</div>
					<ul class="design-type-list">
						<li id="day-signin" @click="goDesign('day-signin')">
							<a style="alignitems: flex-start">
								<img
									src="@/assets/image/startdesign/new_day_sign.png"
									alt="每日一签"
									style="width: 81px; height: 168px"
								/>
							</a>
							<div class="list_item_desc">
								<p>每日一签</p>
								<p>720 x 1280 px</p>
							</div>
						</li>

						<li id="phone-wallpaper" @click="goDesign('phone-wallpaper')">
							<a>
								<img
									src="@/assets/image/startdesign/new_phone_cover.png"
									alt="手机壁纸"
									style="width: 106px; height: 155px"
								/>
							</a>
							<div class="list_item_desc">
								<p>手机壁纸</p>
								<p>720 x 1280 px</p>
							</div>
						</li>

						<li id="friendship-cover" @click="goDesign('friendship-cover')">
							<a>
								<img
									src="@/assets/image/startdesign/new_friend_cover.png"
									alt="朋友圈封面"
									style="width: 125px; height: 155px"
								/>
							</a>
							<div class="list_item_desc">
								<p>朋友圈封面</p>
								<p>1280 x 1184 px</p>
							</div>
						</li>
						<li id="headimg" @click="goDesign('headimg')">
							<a>
								<img
									src="@/assets/image/startdesign/new_head_portrait.png"
									alt="头像"
									style="width: 123px; height: 155px"
								/>
							</a>
							<div class="list_item_desc">
								<p>头像</p>
								<p>400 x 400 px</p>
							</div>
						</li>
						<li id="pc-wallpaper" @click="goDesign('pc-wallpaper')">
							<a style="alignitems: center">
								<img
									src="@/assets/image/startdesign/new_social_life.png"
									alt="朋友圈封面"
									style="width: 158px; height: 94px"
								/>
							</a>
							<div class="list_item_desc">
								<p>电脑壁纸</p>
								<p>1920 x 1080 px</p>
							</div>
						</li>
					</ul>

					<!-- 电商设计 -->
					<div class="create-item-header-type" style="margin: 0 auto 22px">
						<h3 class="create-item-title-type">电商设计</h3>
					</div>
					<ul class="design-type-list">
						<li id="online-main" @click="goDesign('online-main')">
							<a>
								<img
									src="@/assets/image/startdesign/new_shangpinzhutu.png"
									alt="商品主图"
									style="width: 144px; height: 155px"
								/>
							</a>
							<div class="list_item_desc">
								<p>商品主图</p>
								<p>800 x 800 px</p>
							</div>
						</li>
						<li id="shop-recruit" @click="goDesign('shop-recruit')">
							<a>
								<img
									src="@/assets/image/startdesign/new_dianzhao_1.png"
									alt="店招场景"
									style="width: 183px; height: 155px"
								/>
							</a>
							<div class="list_item_desc">
								<p>店招场景</p>
								<p>1920 x 150 px</p>
							</div>
						</li>
						<li id="online-icon" @click="goDesign('online-icon')">
							<a>
								<img
									src="@/assets/image/startdesign/new_zhututubiao.png"
									alt="主图图标"
									style="width: 133px; height: 155px"
								/>
							</a>
							<div class="list_item_desc">
								<p>主图图标</p>
								<p>800 x 800 px</p>
							</div>
						</li>
						<li id="capsule-banner" @click="goDesign('capsule-banner')">
							<a>
								<img
									src="@/assets/image/startdesign/capsule_banner.jpg"
									alt="胶囊banner"
									style="height: 183px"
								/>
							</a>
							<div class="list_item_desc">
								<p>胶囊banner</p>
								<p>750 x 280 px</p>
							</div>
						</li>
					</ul>
					<div class="create-item-header-type" style="margin: 0 auto 22px">
						<h3 class="create-item-title-type">原创插画</h3>
					</div>
					<ul class="design-type-list">
						<li id="vertical-draw" @click="goDesign('vertical-draw')">
							<a style="alignitems: flex-start">
								<img
									src="@/assets/image/startdesign/new_vertical_illustration.png"
									alt="朋友圈封面"
									style="width: 88px; height: 168px"
								/>
							</a>
							<div class="list_item_desc">
								<p>竖版插画</p>
								<p>2000 x 3000 px</p>
							</div>
						</li>
						<li id="illustration-element" @click="goDesign('illustration-element')">
							<a style="alignitems: flex-start">
								<img
									src="@/assets/image/startdesign/new_illustration_element.png"
									alt="插画元素"
									style="width: 130px; height: 167px"
								/>
							</a>
							<div class="list_item_desc">
								<p>插画元素</p>
								<p>2000 x 2000 px</p>
							</div>
						</li>
					</ul>
					<div class="create-item-header-type" style="margin: 0 auto 22px">
						<h3 class="create-item-title-type">短视频/直播</h3>
					</div>
					<ul class="design-type-list">
						<li id="video-cover" @click="goDesign('video-cover')">
							<a>
								<img
									src="@/assets/image/startdesign/new_shipinfengmian.png"
									alt="视频封面"
									style="width: 134px; height: 155px"
								/>
							</a>
							<div class="list_item_desc">
								<p>视频封面</p>
								<p>1242 x 2208 px</p>
							</div>
						</li>
						<li id="side-video" @click="goDesign('side-video')">
							<a>
								<img
									src="@/assets/image/startdesign/new_hengbanshipin.png"
									alt="横版视频封面"
									style="width: 145px; height: 155px"
								/>
							</a>
							<div class="list_item_desc">
								<p>横版视频封面</p>
								<p>1920 x 1080 px</p>
							</div>
						</li>
						<li id="video-frame" @click="goDesign('video-frame')">
							<a style="alignitems: flex-start">
								<img
									src="@/assets/image/startdesign/video_border.jpg"
									alt="视频边框"
								/>
							</a>
							<div class="list_item_desc">
								<p>视频边框</p>
								<p>1242 x 2208 px</p>
							</div>
						</li>
						<li id="live-background" @click="goDesign('live-background')">
							<a style="alignitems: flex-start">
								<img
									src="@/assets/image/startdesign/live_background.jpg"
									alt="直播背景"
								/>
							</a>
							<div class="list_item_desc">
								<p>直播背景</p>
								<p>1242 x 2690 px</p>
							</div>
						</li>
						<li id="live-element" @click="goDesign('live-element')">
							<a style="alignitems: flex-start">
								<img
									src="@/assets/image/startdesign/live_patch.jpg"
									alt="直播上下贴片"
								/>
							</a>
							<div class="list_item_desc">
								<p>直播上下贴片</p>
								<p>1242 x 2690 px</p>
							</div>
						</li>
						<li id="live-pendant" @click="goDesign('live-pendant')">
							<a style="alignitems: flex-start">
								<img
									src="@/assets/image/startdesign/live_pendant.jpg"
									alt="直播挂件"
								/>
							</a>
							<div class="list_item_desc">
								<p>直播挂件</p>
								<p>1200 x 1200 px</p>
							</div>
						</li>
					</ul>

					<div class="create-item-header-type" style="margin: 0 auto 22px">
						<h3 class="create-item-title-type">办公文档</h3>
					</div>
					<ul class="design-type-list">
						<li id="resume" @click="goDesign('resume')">
							<a style="alignitems: flex-end">
								<img
									src="@/assets/image/startdesign/resume.jpg"
									alt="简历"
								/>
							</a>
							<div class="list_item_desc">
								<p>简历</p>
								<p>210mm x 297mm</p>
							</div>
						</li>
						<li id="word-template" @click="goDesign('word-template')">
							<a style="alignitems: flex-end">
								<img
									src="@/assets/image/startdesign/word_template.jpg"
									alt="Word模板"
								/>
							</a>
							<div class="list_item_desc">
								<p>Word模板</p>
								<p>210mm x 297mm</p>
							</div>
						</li>
					</ul>

					
					<div style="width: 100%; height: 160px"></div>
				</section>
			</section>
		</section>
		<el-dialog title="自定义画布尺寸" :visible.sync="dialog">
			<div class="dialog_content">
				<el-input
					placeholder="宽"
					v-model="customSize.width"
					@input="changewidth"
					:class="{
						'error':
							customSize.width && (customSize.width < 40 || customSize.width > 6000),
					}"
				/>
				<span class="cheng">+</span>
				<el-input
					placeholder="高"
					v-model="customSize.height"
					@input="changeheight"
					:class="{
						'error':
							customSize.height &&
							(customSize.height < 40 || customSize.height > 6000),
					}"
				/>
				<span class="px">px(像素)</span>
				<el-button type="primary" @click="startDesign">开始设计</el-button>
				<div class="tips" v-if="error">画布尺寸的取值范围为 40px*40px 至 6000px*6000px</div>
			</div>
		</el-dialog>
	</main>
</template>

<script>
export default {
	data() {
		return {
			dialog: false,
			customSize: {
				width: '',
				height: '',
			},
			error: false,
		}
	},
	methods: {
		goDesign(ckey) {
			this.goDesignworkbench(ckey, '', 'createDesign')
		},
		clickCustomSize() {
			this.dialog = true
		},
		changewidth(value) {
			let { width } = this.customSize
			this.customSize.width = value.replace(/\D/g, '')
			if ((width && width < 40) || width > 6000) {
				this.error = true
			} else {
				this.error = false
			}
		},
		changeheight(value) {
			let { height } = this.customSize
			this.customSize.height = value.replace(/\D/g, '')
			if ((height && height < 40) || height > 6000) {
				this.error = true
			} else {
				this.error = false
			}
		},
		startDesign() {
			if (
				!this.customSize.width ||
				this.customSize.width < 40 ||
				this.customSize.width > 6000 ||
				!this.customSize.height ||
				this.customSize.height < 40 ||
				this.customSize.height > 6000
			) {
				this.error = true
				return false
			}
			let params = {
				size: this.customSize.width + 'x' + this.customSize.height,
				type: 0,
			}
			this.goDesignworkbench(params, '', 'custom')
			this.dialog = false
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep( .el-dialog) {
	width: 560px;
	border-radius: 0;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	margin-top: 0 !important;
	.el-dialog__header {
		width: 100%;
		height: 50px;
		padding: 26px 26px 0;
		text-align: left;
		.el-dialog__title {
			font-size: 18px;
		}
	}
	.el-dialog__body {
		padding: 22px 26px 26px;
		.dialog_content {
			display: flex;
			justify-content: center;
			align-items: center;
			position: relative;
			.el-input {
				width: 130px;
				&::-ms-input-placeholder {
					text-align: center;
				}
			}
			input::-webkit-outer-spin-button,
			input::-webkit-inner-spin-button {
				-webkit-appearance: none !important;
				-moz-appearance: none !important;
				-o-appearance: none !important;
				-ms-appearance: none !important;
				appearance: none !important;
				margin: 0;
			}
			input[type='number'] {
				-webkit-appearance: textfield;
				-moz-appearance: textfield;
				-o-appearance: textfield;
				-ms-appearance: textfield;
				appearance: textfield;
			}
			.error {
				.el-input__inner {
					border-color: #e54b4b !important;
				}
			}
			.cheng {
				display: inline-block;
				font-size: 26px;
				transform: rotate(45deg);
				margin: 0 11px;
				margin-top: -3px;
				color: #3b3946;
			}
			.px {
				color: #3b3946;
				margin-left: 12px;
				white-space: nowrap;
			}
			.el-button {
				width: 130px;
				height: 40px;
				margin-left: 14px;
				background: #5a2df5;
				border-radius: 4px;
				color: #fff;
				transition: all 0.28s;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				font-size: 14px;
			}
			.tips {
				position: absolute;
				left: 0;
				bottom: -20px;
				font-size: 12px;
				color: #e54b4b;
			}
		}
	}
}

#app {
	width: calc(100% - 350px);
	padding: 0 90px 0 60px;
	position: relative;
	top: 60px;
}
.start-design-main {
	margin-top: 0;
}

.header-search {
	display: flex;
}

.create-a-design .create-item-header .create-new {
	background: #5a2df5;
	-o-border-radius: 8px;
	-webkit-border-radius: 8px;
	-moz-border-radius: 8px;
	-ms-border-radius: 8px;
	border-radius: 4px;
}
.create-item-header {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	padding-top: 40px;
	.create-item-title {
		font-size: 24px;
		font-family: PingFang-SC-Medium;
		font-weight: 500;
		color: #333;
		line-height: 33px;
		-webkit-font-smoothing: antialiased;
	}
	.title-split {
		width: 2px;
		height: 20px;
		margin: 6px 30px;
		background: #e7e7ec;
	}
	.create-new {
		width: 110px;
		height: 36px;
		color: #fff;
		text-align: center;
		line-height: 36px;
		font-size: 14px;
		font-family: PingFangSC-Regular;
		font-weight: 400;
		background: #7966f6;
		cursor: pointer;
		border-radius: 4px;
	}
}
.create-a-design .item-split-line {
	height: 2px;
	width: 100%;
	margin-top: 40px;
	background: url('../../../../assets/image/startdesign/line.png') repeat 0 0;
}
.design-type-list {
	margin: 0px auto;
	display: flex;
	justify-content: flex-start;
	align-items: flex-end;
	flex-wrap: wrap;

	li {
		margin: 0px 0px 24px 0px;
		cursor: pointer;
		width: 204px;
		height: 232px;
		margin-bottom: 50px;
		margin-right: 20px;
		a {
			color: #333;
			line-height: 22px;
			display: flex;
			height: 180px;
			background-color: #f4f6fa;
			justify-content: center;
			align-items: flex-end;
			border-radius: 4px;
			transition: all 0.5s;
			&:hover {
				box-shadow: 4px 4px 12px 0px #eaecf1;
				img {
					transform: scale(1.05, 1.05);
				}
			}
			img {
				padding: 0;
				vertical-align: top;
				border: none;
				transition: transform 0.5s;

				// &:hover {
				//     transform: scale(1.05, 1.05);
				// }
			}
			p {
				&:first-of-type {
					margin-top: 20px;
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: rgba(45, 45, 50, 1);
					line-height: 20px;
					text-align: center;
				}

				&:last-of-type {
					font-size: 12px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: rgba(100, 100, 105, 1);
					line-height: 17px;
					text-align: center;
				}
			}
		}
		.list_item_desc {
			height: 52px;
			margin-top: 14px;
			text-align: center;
			font-size: 12px;
			color: #8a898e;
			p:first-child {
				font-size: 14px;
				font-weight: bold;
				line-height: 20px;
				color: #333333;
				font-family: PingFangSC-Medium, PingFang SC;
				margin-bottom: 4px;
			}
			p:last-child {
				font-family: Helvetica;
			}
		}
	}
}
// #socialmedia li {
//     margin: 15px 20px 0px 0px;
// }

.content-modal-create-custom {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: none;
	background: rgba(0, 0, 0, 0.6);
	z-index: 991;
	justify-content: center;
	align-items: center;

	%fontstyle {
		font: {
			size: 14px;
			family: PingFangSC-Regular;
			weight: 400;
		}
	}
	#create_own_size {
		display: block;
		position: fixed;
		left: 50%;
		top: 50%;
		width: 400px;
		height: 276px;
		padding: 0;
		background: #fff;
		z-index: 999;
		@include prefixer(border-radius, 0);
		@include prefixer(box-sizing, border-box);
		@include prefixer(transform, translate(-50%, -50%));

		.modal_head.own_size_header {
			width: 400px;
			height: 40px !important;
			line-height: 40px !important;

			font: {
				size: 16px !important;
				family: PingFangSC-Regular;
				weight: 400;
			}
			color: #fff;
			@include prefixer(border-radius, 0);
		}

		.own_size_main {
			position: absolute;
			top: 40px;
			left: 0;
			width: 400px;
			height: 236px;
			padding: 40px 0;

			@include flex();
			@include flex-direction(column);
			@include justify-content(space-between);
			align-items: center;
			@include prefixer(box-sizing, border-box);

			%formitem_error {
				padding-left: 14px;
				color: #e54b4b;
				line-height: 20px;

				@extend %fontstyle;
			}

			.own_size_con_item {
				@include flex();
				@include flex-direction(column);
				@include prefixer(box-sizing, border-box);

				span:nth-of-type(1) {
					padding-right: 14px;
				}
				span:nth-of-type(2) {
					padding-left: 14px;
					padding-right: 14px;
				}

				span:nth-of-type(3) {
					@extend %formitem_error;
				}
				.form_item lable {
					padding-left: 14px;
					color: #e54b4b;
					line-height: 20px;

					@extend %fontstyle;
				}

				.form_item {
					padding-top: 5px;
					color: #e54b4b;

					line-height: 20px;

					@extend %fontstyle;
					lable {
						@extend %formitem_error;
					}
				}

				input {
					width: 200px;
					height: 32px;
					color: #333;
					border: 1px solid #333;

					text-indent: 10px;
					@extend %fontstyle;

					@include prefixer(border-radius, 4px);
				}
			}
		}

		button {
			width: 200px;
			height: 32px;
			margin-left: -14px;
			line-height: 32px;
			background: #7966fe;
			color: #fff;
			@extend %fontstyle;
			@include prefixer(border-radius, 4px);
		}

		#size_form {
			height: 100%;
		}
	}
}

.dialog-customSize {
	display: flex;
	justify-content: center;
	align-items: center;

	.el-dialog {
		margin: 0 !important;
		border-radius: 4px;
	}

	.el-dialog__header {
		padding: 26px 26px 0;

		.el-dialog__title {
			font-size: 18px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #3b3946;
		}

		.el-dialog__close {
			color: #999999;
			font-size: 20px;
			font-weight: bold;
		}
	}

	.el-dialog__body {
		padding: 22px 26px 26px;

		.dialog-inner {
			position: relative;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.el-input {
				width: 130px;
				height: 40px;

				&.error {
					input {
						border-color: #e54b4b !important;
					}
				}

				input {
					text-align: center;
					border-radius: 4px;

					&:focus {
						border-color: #5a2df5;
					}
					&::-webkit-outer-spin-button,
					&::-webkit-inner-spin-button {
						-webkit-appearance: none;
					}

					&[type='number'] {
						-moz-appearance: textfield;
					}
				}
			}

			i {
				margin: 0 11px;
				font-weight: 600;
				color: #3b3946;
			}
			span {
				color: #3b3946;
				margin-left: 12px;
				white-space: nowrap;
			}
			button {
				width: 130px;
				height: 40px;
				margin-left: 14px;
				background: #5a2df5;
				border-radius: 4px;
				color: #fff;
				transition: all 0.28s;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				font-size: 14px;

				&:hover {
					opacity: 0.95;
				}
			}

			.tips {
				position: absolute;
				left: 0;
				bottom: -20px;
				font-size: 12px;
				color: #e54b4b;
			}
		}
	}
}
.modal_mask {
	z-index: 2002;
}
</style>
